import { render, staticRenderFns } from "./Cancellations.vue?vue&type=template&id=733f941f&"
import script from "./Cancellations.vue?vue&type=script&lang=js&"
export * from "./Cancellations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports